export const MASK = {
    CARD_NUMBER: "9999 9999 9999 9999",
    CARD_EXPIRATION: "99/9999"
}